import React from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import { isEmpty } from "lodash"
import history from "app/history"

import LazyLoadWrapper from "components/common/LazyLoadWrapper"
import PageContainer from "components/common/PageContainer"
import Button from "components/common/Button"
import CardList from "components/common/CardList"
import CustomModal from "components/common/CustomModal"
import StatementModal from "components/common/StatementModal"

import { showAuthModal } from "store/auth/action"
import { fetchBundleById } from "store/courses/action"
import {
  amountFormatter,
  renderIconFileTypes,
  formatDuration,
  isIdVerified,
} from "helpers/util"
import { AUTH_TYPES } from "constants/auth-types"
import { CUSTOM_MODAL_TYPES, RESPONSE_MODAL_TYPES } from "constants/modal-types"
import { STATEMENT_CONTENT } from "constants/message"
import { GOOGLE_SITE_KEY } from "constants/config"

import {
  courseBundleEnrollment,
  startCourse,
  showResponseModal,
  closeResponseModal,
  showConfirmModal,
  closeConfirmModal,
} from "store/user/actions"

import { resendEmail } from "store/auth/action"

import "styles/pages/bundles.scss"
import "react-lazy-load-image-component/src/effects/blur.css"
import { MODAL_MESSAGES } from "constants/message"

class CourseBundleDetails extends React.Component {
  constructor() {
    super()
    this.state = {
      customModalState: false,
      modalType: CUSTOM_MODAL_TYPES.BASIC,
      isEnrolled: false,
      showAffirmationModal: false,
    }
  }

  componentDidMount() {
    const {
      location: { pathname, search },
      fetchBundleById,
      // fetchSimilarCourses,
      showResponseModal,
      closeResponseModal,
    } = this.props

    let currentPath = pathname.split("/")
    if (currentPath[1] === "course-bundle" && !isEmpty(currentPath[2])) {
      let id = currentPath[2].split(/[\s-]+/).pop()
      fetchBundleById(id)
      // fetchSimilarCourses(id);
    }

    let value = search.split("=")
    let modalData = {
      verified: true,
      actionLabel: "OK",
      action: () => closeResponseModal(),
    }
    switch (value[1]) {
      case "S":
        modalData.header = "Payment Successful"
        modalData.modalType = RESPONSE_MODAL_TYPES.SUCCESS
        modalData.message = MODAL_MESSAGES.PAYMENT_COMPLETE
        showResponseModal(modalData)
        break

      case "P":
      case "V":
        modalData.header = "Payment Pending"
        modalData.modalType = RESPONSE_MODAL_TYPES.WARNING
        modalData.message = MODAL_MESSAGES.PAYMENT_PENDING
        showResponseModal(modalData)
        break

      case "F":
        modalData.header = "Payment Failed"
        modalData.modalType = RESPONSE_MODAL_TYPES.ERROR
        modalData.message = MODAL_MESSAGES.PAYMENT_FAILED
        showResponseModal(modalData)
        break

      default:
        break
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname: prevPathname },
    } = prevProps

    const {
      fetchBundleById,
      // fetchSimilarCourses,
      location: { pathname },
    } = this.props

    if (pathname !== prevPathname) {
      let currentPath = pathname.split("/")
      if (currentPath[1] === "course" && !isEmpty(currentPath[2])) {
        let id = currentPath[2].split(/[\s-]+/).pop()

        fetchBundleById(id)
        // fetchSimilarCourses(id);
      }
    }
  }

  displayCourseware(coursewares) {
    if (Array.isArray(coursewares)) {
      return (
        <React.Fragment>
          {coursewares.map((item) => (
            <div className="accordion__content" key={item.id}>
              <span className="icon accordion__content-icon">
                <i className={renderIconFileTypes(item.type)} />
              </span>
              <span>{item.name}</span>
            </div>
          ))}
        </React.Fragment>
      )
    } else {
      return <p>N/A</p>
    }
  }

  customModalToggle = () => {
    this.setState((prevState) => ({
      customModalState: !prevState.customModalState,
    }))
  }

  showEnrollNow = () => {
    const {
      auth,
      courses: {
        selectedBundle: { fee, config, slug },
      },
      user: { userDetails },
      school: { schoolData },
      showAuthModal,
    } = this.props

    const { config: schoolConfig = {} } = schoolData
    const schoolPrimaryId = schoolConfig?.products?.primary_id || false
    const userIdVerified = isIdVerified(userDetails?.user_ids, schoolPrimaryId)

    if (!auth.isAuthorized) {
      showAuthModal({ type: AUTH_TYPES.LOGIN })
    } else if (!auth.userId) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.NOT_STUDENT })
      this.customModalToggle()
    } else if (!userDetails?.is_verified) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.VERIFY_EMAIL })
      this.customModalToggle()
    } else if (userDetails.step === "1") {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.INC_PROFILE })
      this.customModalToggle()
    } else if (
      schoolData?.config?.products?.mcle &&
      !userDetails?.info_submitted
    ) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.INC_MCLE_PROFILE })
      this.customModalToggle()
    } else if (config?.require_kyc && !userIdVerified) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.INC_KYC })
      this.customModalToggle()
    } else if (schoolData?.config?.products?.mcle) {
      this.affirmationModalToggle()
    } else {
      if (fee === 0) {
        this.setState({ modalType: CUSTOM_MODAL_TYPES.TEXT })
        this.customModalToggle()
      } else {
        history.push(`/course-bundle/payment/${slug}`)
      }
    }
  }

  showPaymentPage = () => {
    const {
      courses: {
        selectedBundle: { fee, slug },
      },
    } = this.props

    if (fee === 0) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.TEXT })
      this.customModalToggle()
    } else {
      history.push(`/course-bundle/payment/${slug}`)
    }
  }

  onSubmitEnrollment = (data) => {
    const {
      courseBundleEnrollment,
      school: { schoolData },
      courses: {
        selectedBundle: { id },
      },
    } = this.props
    const { config: schoolConfig = {} } = schoolData

    let freeCourseEnrollment = {
      bundle: id,
      action: "free",
    }

    if (schoolConfig?.products?.mcle) {
      freeCourseEnrollment.compliance_period = data
    }

    this.customModalToggle()
    courseBundleEnrollment(freeCourseEnrollment)
  }

  handleCheckIfEnrolled = (id) => {
    const {
      courses: {
        selectedBundle: { status },
      },
    } = this.props

    let enrollmentDetails = {}
    if (status === "pending") {
      enrollmentDetails.isEnrolled = false
      enrollmentDetails.label = "Payment Pending"
    } else if (status === "paid") {
      enrollmentDetails.isEnrolled = true
      enrollmentDetails.label = "Enrolled"
    } else {
      enrollmentDetails.isEnrolled = false
      enrollmentDetails.label = "Enroll Now"
    }
    return enrollmentDetails
  }

  startCourse = (id) => {
    const { startCourse } = this.props
    startCourse({ id: id })
  }

  handleModalAction = (data) => {
    const { modalType } = this.state
    if (modalType === CUSTOM_MODAL_TYPES.INC_PROFILE) {
      this.redirectToProfile()
    } else if (modalType === CUSTOM_MODAL_TYPES.INC_MCLE_PROFILE) {
      this.redirectToMCLEProfile()
    } else if (modalType === CUSTOM_MODAL_TYPES.INC_KYC) {
      this.redirectToProfileKYC()
    } else if (modalType === CUSTOM_MODAL_TYPES.VERIFY_EMAIL) {
      this.handleResendEmail()
    } else {
      this.onSubmitEnrollment(data)
    }
  }

  handleResendEmail = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(GOOGLE_SITE_KEY, { action: "submit" })
        .then((token) => {
          this.props.resendEmail({
            "g-recaptcha-response": token,
          })
        })
    })
  }

  checkMCLEStatus = () => {
    const {
      school: {
        schoolData: { config: schoolConfig },
      },
    } = this.props

    if (schoolConfig?.products?.mcle === true) {
      this.affirmationModalToggle()
    } else {
      this.showEnrollNow()
    }
  }

  affirmationModalToggle = () => {
    this.setState((prevState) => ({
      showAffirmationModal: !prevState.showAffirmationModal,
    }))
  }

  redirectToEmailProfile = () => {
    history.push("/student/email")
  }

  redirectToMCLEProfile = () => {
    history.push("/student/mcle-profile")
  }

  redirectToProfileKYC = () => {
    history.push("/student/authenticate-id")
  }

  redirectToProfile = () => {
    history.push("/student/profile")
  }

  render() {
    const {
      courses: { selectedBundle = {}, isLoadingSelectedBundle },
    } = this.props

    const { customModalState, modalType, showAffirmationModal } = this.state

    let data = this.handleCheckIfEnrolled(selectedBundle.id)

    return (
      <PageContainer
        isPageLoading={isLoadingSelectedBundle}
        className="bundle-details"
      >
        {selectedBundle.image && (
          <LazyLoadWrapper
            className="course-cover"
            src={`${selectedBundle.image}`}
            effect="blur"
            width="100%"
          />
        )}
        <div className="bundle-container">
          <div className="bundle-wrapper">
            {selectedBundle.image && (
              <LazyLoadWrapper
                className="course-cover"
                src={`${selectedBundle.image}`}
                effect="blur"
                width="100%"
              />
            )}
            <div className="course-info">
              <div className="info-items">
                <p className="course-label">Courses</p>
                <p className="course-text">
                  <span className="icon-course" />
                  {selectedBundle.courses?.length} Course(s)
                </p>
              </div>
              <div className="info-items">
                <p className="course-label">Units</p>
                <p className="course-text">
                  <span className="icon-outline" />
                  {selectedBundle.units || 0} Unit(s)
                </p>
              </div>
              {selectedBundle?.config?.duration > 0 ? (
                <>
                  <div className="info-items">
                    <p className="course-label">Course Duration</p>
                    <p className="course-text">
                      <span className="icon-timer" />
                      {formatDuration(selectedBundle?.config?.duration)}
                    </p>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="info-items">
                <p className="course-label">Bundle Fee</p>
                <p className="course-text">
                  <span className="icon-payment" />
                  {`${
                    selectedBundle.price
                      ? `P${amountFormatter(selectedBundle.price)}`
                      : "FREE"
                  }`}
                </p>
              </div>
              {!data.isEnrolled ? (
                <Button
                  loading={isLoadingSelectedBundle}
                  disabled={data.isEnrolled}
                  label={data.label}
                  onClick={() => this.showEnrollNow()}
                />
              ) : (
                ""
              )}
            </div>
            {selectedBundle.courses && selectedBundle.courses?.length ? (
              <>
                <h1 className="bundle-title">{selectedBundle?.name}</h1>
                {selectedBundle.description && (
                  <>
                    <h4 className="bundle-kicker">About this bundle</h4>
                    <p className="bundle-description">
                      {selectedBundle.description}
                    </p>
                  </>
                )}
                <h3 className="bundle-kicker">Included Courses</h3>
                <CardList
                  data={selectedBundle.courses}
                  loading={isLoadingSelectedBundle}
                />
              </>
            ) : (
              <div className="course-description">No data to display</div>
            )}
          </div>
        </div>
        <StatementModal
          isOpen={showAffirmationModal}
          closeModal={() => this.affirmationModalToggle()}
          title="Statement of Affirmation"
          consentLabel="I am confirming that I have read the Statement of Affirmation and agree to its contents."
          message={STATEMENT_CONTENT["AFFIRMATION"]}
          onConfirm={() => {
            this.affirmationModalToggle()
            this.showPaymentPage()
          }}
        />
        <CustomModal
          type={modalType}
          isOpen={customModalState}
          closeModal={this.customModalToggle}
          data={selectedBundle}
          handleModalAction={this.handleModalAction}
        />
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  user: state.userReducer,
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBundleById,
      // fetchSimilarCourses,
      courseBundleEnrollment,
      startCourse,
      resendEmail,
      showResponseModal,
      closeResponseModal,
      showConfirmModal,
      closeConfirmModal,
      showAuthModal,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CourseBundleDetails)
